import type { SessionJig } from '@features/workshop-plan/types';

/** Jigs in the order they are offered: by ascending machine id, blocked ones last. */
export const sortJigs = (jigs: SessionJig[]): SessionJig[] =>
  [...jigs].sort((a, b) => Number(a.blocked) - Number(b.blocked) || a.machineId - b.machineId);

/**
 * Jig of the session: the one the operator chose if it can still be used, otherwise the first free one, otherwise the
 * first one not blocked. `null` when every machine is blocked.
 */
export const pickJig = (jigs: SessionJig[], chosenId: number | null): SessionJig | null => {
  const chosen = jigs.find((jig) => jig.id === chosenId && !jig.blocked);

  if (chosen) return chosen;

  const usable = sortJigs(jigs).filter((jig) => !jig.blocked);

  return usable.find((jig) => jig.ongoingSessions.length === 0) ?? usable[0] ?? null;
};
